import { render, staticRenderFns } from "./WeekNavHeader.vue?vue&type=template&id=2ddcb753&scoped=true"
import script from "./WeekNavHeader.vue?vue&type=script&lang=js"
export * from "./WeekNavHeader.vue?vue&type=script&lang=js"
import style0 from "./WeekNavHeader.vue?vue&type=style&index=0&id=2ddcb753&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddcb753",
  null
  
)

export default component.exports